import { formatDistanceToNow, format, isWithinInterval } from 'date-fns';

import { TeamsEvent } from '@/apps/TeamsSchedule/stores/useTeamsScheduleStore';
import { useDateLocale } from '@/common/hooks/useDateLocale';

interface EventCardProps {
  event: TeamsEvent;
}

export const EventCard = ({ event }: EventCardProps) => {
  const { locale, timeFormat } = useDateLocale();
  const isNow = isWithinInterval(new Date(), {
    start: event.startTime,
    end: event.endTime,
  });

  const timeFromNow = formatDistanceToNow(event.startTime, { addSuffix: true, locale });
  const formattedTime = `${format(event.startTime, timeFormat, { locale })} - ${format(event.endTime, timeFormat, { locale })}`;

  return (
    <div className="p-4 bg-white rounded-lg shadow hover:shadow-md transition-shadow border border-gray-100">
      <div className="flex justify-between items-start gap-4">
        <div className="flex-grow">
          <h3 className="text-lg font-medium text-gray-800">{event.title}</h3>
          <p className="text-sm font-medium text-gray-700">{formattedTime}</p>
          <div>
            {isNow ? (
              <span className="px-2 py-0.5 text-xs font-medium bg-green-100 text-green-800 rounded-full">
                Now
              </span>
            ) : (
              <p className="text-sm text-gray-500 mt-0.5">{timeFromNow}</p>
            )}
          </div>
        </div>
        {event.joinUrl && (
          <a
            className="inline-flex items-center gap-2 px-4 py-2 bg-blue-50 text-blue-600 rounded-lg hover:bg-blue-100 transition-colors text-sm font-medium"
            href={event.joinUrl}
            rel="noopener noreferrer"
            target="_blank"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
              />
            </svg>
            Join
          </a>
        )}
      </div>
    </div>
  );
};
